import * as React from "react";
import styled from "styled-components";
import { bottomGradient, topGradient } from "../../../../ui/_utils/styleUtils";
import {
  SettingsHeaderDesktop,
  SettingsSubHeaderDesktop
} from "../../../../ui/SettingsHeaderDesktop";
import { SettingsWindowDesktop } from "../../../../ui/SettingsWindowDesktop";
import { E2EIdentifier } from "../../../e2e/E2EIdentifier";
import { AutoplayAdvancedDesktop } from "./AutoplayAdvancedDesktop";
import { IAutoplaySettingsDesktop } from "./AutoplaySettingsDesktop";
import { SettingButton } from "./components/AutoplayButtons";

const renderRounds = (availableRounds, roundsSelected, selectRounds) => {
  return availableRounds.map((value, index) => {
    const active = value === roundsSelected;
    const onClick = () => selectRounds(value);

    return (
      <SettingButton
        key={index}
        label={value}
        data-e2e-id={`${E2EIdentifier.AUTOPLAY_ROUNDS_BUTTON}-${value}`}
        active={active}
        onClick={onClick}
      />
    );
  });
};

export class AutoplaySettingsDesktopDefaultView extends React.PureComponent<
  IAutoplaySettingsDesktop,
  any
> {
  private ref: React.RefObject<Element> = React.createRef();

  constructor(props: IAutoplaySettingsDesktop) {
    super(props);
  }

  public render() {
    const {
      available,
      isOpen,
      onClose,
      roundsSelected,
      availableRounds,
      settings,
      triggerAutoplaySettingChangeRequest,
      triggerAutoplaySettingsResetRequest,
      triggerAutoplayRoundsChangeRequest,
      t
    } = this.props;

    if (!isOpen) {
      return null;
    }
    return (
      <SettingsWindowDesktop onClose={onClose} isOpen={isOpen}>
        <ScrollableContent ref={this.ref}>
          <SettingsHeaderDesktop
            dataE2EId={E2EIdentifier.AUTOPLAY_TITLE}
            title={t("AutoplayTitle")}
          />
          {available && (
            <SettingsContent>
              <div>
                <SettingsSubHeaderDesktop
                  data-e2e-id={E2EIdentifier.AUTOPLAY_ROUNDS_SUBTITLE}
                >
                  {t("AutoplaySubTitle")}
                </SettingsSubHeaderDesktop>
                <Settings data-e2e-id={E2EIdentifier.AUTOPLAY_ROUNDS_CONTAINER}>
                  {renderRounds(
                    availableRounds,
                    roundsSelected,
                    triggerAutoplayRoundsChangeRequest
                  )}
                </Settings>
                <AutoplayAdvancedDesktop
                  settings={settings}
                  disabled={!roundsSelected}
                  onChange={triggerAutoplaySettingChangeRequest}
                  onReset={triggerAutoplaySettingsResetRequest}
                  resetButtonLabel={t("Reset")}
                  requiredText={t("Required")}
                  title={t("AutoplaySettingsTitle")}
                  subtitle={t("AutoplaySettingsSubTitle")}
                />
              </div>
            </SettingsContent>
          )}
        </ScrollableContent>
      </SettingsWindowDesktop>
    );
  }
}

export const ScrollableContent = styled.div`
  overflow-y: auto;
  overflow-x: hidden;

  ${topGradient};
  ${bottomGradient};

  &:before,
  &:after {
    position: sticky;
  }
`;

export const Settings = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-content: stretch;
`;

export const SettingsContent = styled.div`
  padding: 0 16.4%;
`;
